import Enumerable from "linq";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean, IXElementContentsObjectRelationalItemBean } from "../../../beans";
import { ArrayComplexTranslator } from "../../values";

export class RelationTranslator {
  constructor(private readonly _action: string) {}

  from<T>(bean: IXElementContentsObjectBean, from: (i: IXElementContentsObjectRelationalItemBean[]) => T, defaultValue: T = null): T {
    const items = this.itemsFrom(bean);
    return (0 < items.length)
      ? from(items)
      : defaultValue;
  }

  itemsFrom(bean: IXElementContentsObjectBean): IXElementContentsObjectRelationalItemBean[] {
    const relation = Enumerable.from(this.arrayComplex.from(bean.relational))
      .firstOrDefault(r => r["@action"] === this._action);
    return this.arrayComplex.from(relation ? relation.relationalitem : []);
  }

  to<T>(items: IXElementContentsObjectRelationalItemBean[]): IXElementContentsObjectRelationalBean {
    return (items && (0 < items.length))
      ? {
        "@action": this._action,
        "relationalitem": this.arrayComplex.to(items),
      }
      : undefined;
  }

  private readonly arrayComplex = new ArrayComplexTranslator();
}
